import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable, of, Subject } from 'rxjs';
import { Label, Note, Task } from 'app/modules/gen/notes/notes.types';
import { EntityService } from '../../entity.service';
import { NoteEventsComponent } from '../note-events/note-events.component';
import { Router } from '@angular/router';

@Component({
    selector: 'add-note',
    templateUrl: './add-note.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddNoteComponent implements OnInit, OnDestroy {
    note$: Observable<Note>;
    labels$: Observable<Label[]>;
    hndlr_nm;

    noteChanged: Subject<Note> = new Subject<Note>();
    private _unsubscribeAll: Subject<any> = new Subject<any>();
    enty_ky: number;
    loader
    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private _entityService: EntityService,
        private _matDialogRef: MatDialogRef<AddNoteComponent>, private _router: Router,
    ) {
    }


    ngOnInit(): void {
        if (this.dialogData) {
            this.hndlr_nm = this.dialogData.hndlr_nm;
            this.enty_ky = this.dialogData.enty_ky;
            if (this.dialogData.edit_in) {
                const note = {
                    content: this.dialogData.editData.nte_tx,
                    nte_id: this.dialogData.editData.nte_id
                };
                this.note$ = of(note);
            }
            else {
                const note = {
                    content: '',
                };

                this.note$ = of(note);
            }
        }
        else {
            this.hndlr_nm = 'gen_nte_lst_t';
            this.enty_ky = 1;
            const note = {
                content: '',
            };

            this.note$ = of(note);
        }
    }


    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }



    createNote(note: Note): void {
        note['hndlr_nm'] = this.hndlr_nm;
        note['enty_ky'] = this.enty_ky;
        this.loader=true
        this._entityService.new_note(note).subscribe((res: any) => {
            this.loader=false
            if (res.status == 200) {
                this._entityService.get_notes();
                this._matDialogRef.close();
                this._entityService.openSnackBar('Added note successfully', 'mat-primary')
            }
        }, (err) => {
        })
    }
    updateNote(note: Note): void {
        this.loader=true
        note['hndlr_nm'] = this.hndlr_nm;
        note['enty_ky'] = this.enty_ky;
        this._entityService.update_note(note).subscribe((res: any) => {
            this.loader=false
            if (res.status == 200) {
                this._entityService.get_notes();
                this._matDialogRef.close();
                this._entityService.openSnackBar('note updated successfully', 'mat-primary')
            }
        }, (err) => {
        })
    }
}
